<div class="nudge-wrapper">
  <div class="image">
    <img loading="lazy" class="img1" [attr.data-src]="config?.imgUrl" alt="">
    <img *ngIf="isMobile" loading="lazy" class="img2" [attr.data-src]="'/assets/images/heartfilled_red.png'" alt="">
  </div>
  <div class="content">
    <div class="title">Help others like {{config?.beneficiaryName}}!</div>
    <div class="sub">Thanks to your previous donation, {{config?.beneficiaryName}}'s got a reason to smile & live again!</div>
  </div>
</div>